import React from 'react';
import isNil from 'lodash/isNil';
import Table from 'core/components/VirtualTable';
import {
  PCCCcmCallDTO,
} from 'dtos';
import columns from 'pages/Dashboard/pages/Dashboard/PCCOverview/sidePanel/ccmCallColumns';
import {
  useGetCcmCallsByPatientId,
} from 'views/EMR/hooks/pcc';
import {
  DateRange,
} from 'types/dateRange';

type Props = {
  patientId: number;
  dateRange: DateRange;
};

export default function PatientCcmContent({
  patientId,
  dateRange,
}: Props) {
  const { data, isFetching } = useGetCcmCallsByPatientId(patientId, dateRange);
  const calls = data ?? [];
  const isInitialLoading = isFetching && isNil(data);

  return (
    <div className="relative flex min-h-0 flex-1 flex-col overflow-y-hidden">
      <Table<PCCCcmCallDTO>
        data={calls}
        columns={columns}
        getRowId={(row, index) => row.callId ?? `ccm-call-${index}`}
        loading={isInitialLoading}
        emptySlot={(
          <div className="flex w-full flex-col gap-3 bg-gray-50 p-4">
            <p className="text-left text-sm text-gray-600">
              No CCM calls found
            </p>
          </div>
        )}
        loadingSlot="Loading CCM calls..."
        classes={{
          table: '!items-stretch !justify-start',
          header: '!justify-start px-4 !border-t-0',
          outerColumn: '!items-start',
          column: '!text-left',
          scrollContainer: 'justify-center items-center',
          outerRow: '!w-[calc(100%-16px)] left-4',
          row: '!items-stretch !pt-1 !justify-start',
          cell: '!items-start !h-auto !py-2',
        }}
      />
    </div>
  );
}
